import styled, { css } from '../styled-components';

interface BoxProps {
    selected: boolean;
}

const Box = styled<BoxProps, any>('div')`
    min-height: 4em;
    padding: 1em;
    box-shadow: 0 0 0.4em rgba(0, 0, 0, 0.3);
    margin-bottom: 2em;
    transition: box-shadow 0.2s ease-in-out;
    &:hover {
        box-shadow: 0 0 1.2em rgba(0, 0, 0, 0.3);
    }
    ${props =>
        props.selected &&
        css`
            color: white;
            background-color: ${p => p.theme.primary};
        `};
`;

export default Box;



// WEBPACK FOOTER //
// ./src/components/Box.tsx